import React from "react";
import { twMerge } from "tailwind-merge";
import Button from "../Button";
import StickyBar from "../StickyBar";

export function getStickyCtaState({
  isCancelled,
  myRsvp,
  requiresInvite,
  isHosting,
  inviteStatus,
  isFull,
  isNotConfirmed,
}) {
  if (isCancelled || myRsvp || isHosting) return null;
  if (requiresInvite) {
    if (inviteStatus === "pending") return null;
    if (inviteStatus === "accepted") return null;
    if (inviteStatus === "rejected") {
      return { label: "Request again →", disabled: false, testId: "sticky-request-invite-btn" };
    }
    return {
      label: isFull ? "Full — no spots left" : "Request invite →",
      disabled: !!isFull,
      testId: "sticky-request-invite-btn",
    };
  }
  return {
    label: isFull ? "Full — no spots left" : isNotConfirmed ? "RSVP anyway →" : "RSVP →",
    disabled: !!isFull,
    testId: "sticky-open-rsvp-btn",
  };
}

/**
 * Mobile-only sticky RSVP / invite bar. `visible` is driven by scroll: hidden while the
 * hero banner is on screen so we don't duplicate the primary CTA at the top.
 */
export default function StickyCta({
  cta,
  visible,
  onOpenForm,
  onOpenInviteForm,
  requiresInvite,
  loading = false,
}) {
  if (!cta) return null;
  const onClick = requiresInvite ? onOpenInviteForm : onOpenForm;
  return (
    <StickyBar
      testId="event-sticky-cta"
      hideOnDesktop
      aria-hidden={!visible}
      className={twMerge(
        "bg-canvas/55 backdrop-blur-[2px] border-t-0 [background-image:radial-gradient(ellipse_140%_120%_at_50%_100%,rgba(222,124,67,0.08)_0%,rgba(157,78,221,0.05)_45%,transparent_70%)] transition-transform duration-200 ease-out motion-reduce:transition-none",
        visible ? "translate-y-0" : "translate-y-full pointer-events-none"
      )}
    >
      <Button
        variant="primary"
        size="lg"
        className="w-full"
        onClick={onClick}
        disabled={cta.disabled}
        loading={loading}
        loadingLabel="Loading RSVP options"
        data-testid={cta.testId}
      >
        {cta.label}
      </Button>
    </StickyBar>
  );
}
